import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromSelectedItem from './+state/selected-item.reducer'
import { SelectedItemEffects } from './+state/selected-item.effects'
import { SelectedItemFacade } from './+state/selected-item.facade'
import { SelectedItemBidEffects } from './+state/selected-item-bid.effects'
import { SelectedItemDonationEffects } from './+state/selected-item-donation.effects'
import { SelectedItemPurchaseEffects } from './+state/selected-item-purchase.effects'
import { SelectedItemRafflePurchaseEffects } from './+state/selected-item-raffle-purchase.effects'

export const SELECTED_ITEM_EFFECTS = [
  SelectedItemEffects,
  SelectedItemBidEffects,
  SelectedItemDonationEffects,
  SelectedItemPurchaseEffects,
  SelectedItemRafflePurchaseEffects,
]

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromSelectedItem.SELECTED_ITEM_FEATURE_KEY, fromSelectedItem.reducer),
    EffectsModule.forFeature(SELECTED_ITEM_EFFECTS),
  ],
  providers: [SelectedItemFacade],
})
export class GbFrontSelectedItemDataAccessModule {}
